import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { AppLayout } from "@/components/layout/AppLayout";
import HomePage from "@/pages/HomePage";
import PersonsPage from "@/pages/PersonsPage";
import PersonDetailPage from "@/pages/PersonDetailPage";
import PersonFormPage from "@/pages/PersonFormPage";
import OrgsPage from "@/pages/OrgsPage";
import OrgDetailPage from "@/pages/OrgDetailPage";
import OrgFormPage from "@/pages/OrgFormPage";
import GroupsPage from "@/pages/GroupsPage";
import GroupDetailPage from "@/pages/GroupDetailPage";
import ListsPage from "@/pages/ListsPage";
import ListDetailPage from "@/pages/ListDetailPage";
import LoginPage from "@/pages/LoginPage";
import ProfilePage from "@/pages/ProfilePage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ExpertisesPage from "@/pages/ExpertisesPage";
import ExpertiseDetailPage from "@/pages/ExpertiseDetailPage";
import { KINDS } from "@/lib/kinds";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route element={<AppLayout />}>
              <Route index element={<HomePage />} />
              <Route path="personnes" element={<PersonsPage />} />
              <Route path="personnes/nouveau" element={<PersonFormPage />} />
              <Route path="personnes/:id" element={<PersonDetailPage />} />
              <Route path="personnes/:id/modifier" element={<PersonFormPage />} />
              <Route path="entreprises" element={<OrgsPage key="orgs" />} />
              <Route path="entreprises/nouvelle" element={<OrgFormPage />} />
              <Route path="entreprises/:id" element={<OrgDetailPage />} />
              <Route path="entreprises/:id/modifier" element={<OrgFormPage />} />
              <Route path="locataires" element={<OrgsPage mode="tenants" key="tenants" />} />
              <Route path="locataires/nouveau" element={<OrgFormPage key="tenant-new" />} />
              <Route path="locataires/:id" element={<OrgDetailPage />} />
              <Route path="locataires/:id/modifier" element={<OrgFormPage />} />
              {Object.values(KINDS).map((k) => [
                <Route key={k.key} path={k.path.slice(1)} element={<GroupsPage kind={k.key} />} />,
                <Route key={`${k.key}-detail`} path={`${k.path.slice(1)}/:id`} element={<GroupDetailPage kind={k.key} />} />,
              ])}
              <Route path="expertises" element={<ExpertisesPage />} />
              <Route path="expertises/:id" element={<ExpertiseDetailPage />} />
              <Route path="listes" element={<ListsPage />} />
              <Route path="listes/:id" element={<ListDetailPage />} />
              <Route path="connexion" element={<LoginPage />} />
              <Route path="profil" element={<ProfilePage />} />
              <Route path="admin" element={<AdminPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Routes>
          <Toaster position="top-center" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
